<app-select-field
  class="select-field"
  [label]="'LABEL.RECURRING' | translate"
  fieldId="document_schedule_interval_field"
  [formControl]="scheduleControl"
  [values]="selectOptions"
  [icon]="featureHighlightIcon"
  [blocker]="showUpgradeDialogCallback"
  [description]="nextRunDateInfo"
  [dynamicVAlignment]="true"
  [trackingObject]="documentTrackingObject"
  [trackingTapped]="recurringDropdownTapped"
  [trackingAdditionalProperties]="recurringAdditionalProperties"
  (onClickIcon)="showFeatureHighlightDialog()"
>
</app-select-field>
